import { useMemo } from 'react';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { LlmSanitizerConfig } from './LlmSanitizer';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "Markdown__StyledSpan",
  componentId: "buv5ui-0"
})(["white-space:pre-line;> *:last-child{margin-bottom:0;}"]);
const BACKTICK_REGEX = /`([^`]+)`/g;
const replaceBackticksWithCodeBlocks = text => text.replace(BACKTICK_REGEX, '<code class="inline-code-snippet" role="code">$1</code>');
const Markdown = ({
  html
}) => {
  const sanitizedHtml = useMemo(() => {
    return sanitize(html, LlmSanitizerConfig);
  }, [html]);
  const decoratedHtml = useMemo(() => {
    const htmlWithCodeDecorations = replaceBackticksWithCodeBlocks(sanitizedHtml);
    return htmlWithCodeDecorations;
  }, [sanitizedHtml]);
  return /*#__PURE__*/_jsx(StyledSpan, {
    dangerouslySetInnerHTML: {
      __html: decoratedHtml
    }
  });
};
export default Markdown;